import React from "react";
import LogoItem from "./logoItem";

function Logos() {
  return <LogoItem />;
}

export default Logos;
